import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { getCookie } from "../../utils/cookies";
import MainLayout from "../../layouts/MainLayout";

const MainRoot = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const access_token = getCookie("LuxMartAdminDashboardAccessToken");
    if (!access_token) {
      navigate("/auth/login");
    }
  }, [navigate]);
  return (
    <div>
      <MainLayout />
    </div>
  );
};

export default MainRoot;
